import { useState, useEffect } from "react";
import classes from "../Etablissements/Etablissements.module.css";
import {
  Button,
  Card,
  Dropdown,
  Modal,
  notification,
  Space,
  Spin,
  Table,
  Tooltip,
} from "antd";

import { DownOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../utils/axios";
import { useNavigate } from "react-router-dom";
import {
  addAffaire,
  getCheckModificationApprenant,
  getDetailsEpfByDirector,
  getInfoApprenant,
  getSchema,
  handleGetComment,
  updateActionAffaire,
  uploadDocumentAffaire,
} from "../../api/geoprod";
import dayjs from "dayjs";
import CommentModal from "../Etablissements/CreateEpf/Modals/CommentModal";
import { downloadFile } from "../../utils";
import { useLoader } from "../../context/LoaderContext";

const PreInscritList = () => {
  const { t } = useTranslation();
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [demandeurDetails, setDemandeurDetails] = useState("");
  const [commentaire, setCommentaire] = useState([]);
  const { setIsLoading } = useLoader();
  const role = localStorage.getItem("role");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  // const rowSelection = {
  //   onChange: (selectedRowKeys, selectedRows) => {
  //     setSelectedRows(selectedRows);
  //   },
  //   getCheckboxProps: (record) => ({
  //     disabled: record.authorized === "Non",
  //   }),
  // };
  const updatePreInscrit = (record) => {
    // debugger
    navigate("/pre-inscrit/" + record?.id_formation, {
      state: {
        type: "modification",
        id_apprenant: record.id,
        id_specialite:record?.data_from?.id_specialite
      },
    });
  };

  const consulterPreInscrit = (record, type, dataAffaire) => {
    navigate("/pre-inscrit/" + record?.id_formation, {
      state: {
        type: type,
        id_apprenant: record.id,
        dataAffaire: dataAffaire,
        id_affaire:record?.demande_eligibilite_id,
         id_specialite:record?.data_from?.id_specialite
      },
    });
  };

  const ajouterDemandeVerification = (record) => {
    setLoading(true);
    getCheckModificationApprenant(record?.id)
      .then((response) => {
        if (response?.modifiable) {
          getInfoApprenant(record.id)
            .then(async (responseDetailsApprenant) => {
              getDetailsEpfByDirector()
                .then(async (responseDetailsEpf) => {
                 const id_sp = JSON.parse(responseDetailsApprenant?.mainProspect?.data_from).id_specialite
                  const item = responseDetailsEpf?.data?.message?.training_nature_data?.find( 
                    (entry) => entry.training_type_data_specialty_id === id_sp
                  );
                  const json_prod = {
                    registration_number: 
                      responseDetailsEpf?.data?.message?.registration_number,
                    training_nature_data:item,
                    establishment_data_commercial_name:
                      responseDetailsEpf?.data?.message
                        ?.establishment_data_commercial_name,
                    establishment_data_official_name:
                      responseDetailsEpf?.data?.message
                        ?.establishment_data_official_name,
                    legal_entity_official_name:
                      responseDetailsEpf?.data?.message
                        ?.legal_entity_official_name,
                    establishment_director_data_last_name:
                      responseDetailsEpf?.data?.message
                        ?.establishment_director_data_last_name,
                    establishment_director_data_first_name:
                      responseDetailsEpf?.data?.message
                        ?.establishment_director_data_first_name,
                    establishment_data_governorate:
                      responseDetailsEpf?.data?.message
                        ?.establishment_data_governorate,
                    establishment_data_delegation:
                      responseDetailsEpf?.data?.message
                        ?.establishment_data_delegation,
                    establishment_data_tax_number:
                      responseDetailsEpf?.data?.message
                        ?.establishment_data_tax_number,
                    legal_entity_tax_number:
                      responseDetailsEpf?.data?.message
                        ?.legal_entity_tax_number,
                    numero_matricule_fiscal_numero_IURNE:
                      responseDetailsEpf?.data?.message
                        ?.numero_matricule_fiscal_numero_IURNE,
                    numero_matricule_fiscal_IURNE:
                      responseDetailsEpf?.data?.message
                        ?.numero_matricule_fiscal_IURNE,
                    establishment_director_data_phone_number:
                      responseDetailsEpf?.data?.message
                        ?.establishment_director_data_phone_number,
                    establishment_data_training_type:
                      responseDetailsEpf?.data?.message
                        ?.establishment_data_training_type,
                    id_formation: record.id_formation,
                    infoEligibiliteEtrangers: [
                      {
                        label: "Nationalité - الجنسية",
                        value:
                          responseDetailsApprenant?.mainProspect?.nationality,
                        name: "nationality",
                        type: "text",
                      },

                      // responseDetailsApprenant?.mainProspect
                      //   ?.etablissement_formation_origine && 
                        {
                        label:
                          "Etablissement de formation d’origine - مؤسسة التكوين التي حصل منها على آخر شهادة",
                        value:
                          responseDetailsApprenant?.mainProspect
                            ?.etablissement_formation_origine ? responseDetailsApprenant?.mainProspect
                            ?.etablissement_formation_origine : "",
                        type: "text",

                        name: "etab_origin",
                      },

                      responseDetailsApprenant?.mainProspect
                        ?.etablissement_formation_origine_autre &&   responseDetailsApprenant?.mainProspect
                        ?.etablissement_formation_origine === parseInt(import.meta.env.VITE_APP_ID_ETABLISSEMENT_ORIGINE_EQUIVALENCE) && {
                        label: "",
                        value:
                          responseDetailsApprenant?.mainProspect
                            ?.etablissement_formation_origine_autre,
                        type: "text-area",
                        name: "autre_textarea",
                      },

                      {
                        label: "Date de naissance - تاريخ الولادة",
                        value: responseDetailsApprenant?.mainProspect?.DN,
                        name: "date_naissance",
                        type: "text",
                      },
                      responseDetailsApprenant?.mainProspect?.nationality ===
                        "تونسية" && {
                        label: "Numéro CIN - رقم بطاقة التعريف الوطنية",
                        value: responseDetailsApprenant?.mainProspect?.cin
                          ? responseDetailsApprenant?.mainProspect?.cin
                          : "",
                        type: "text",
                         name: "num_cin",
                      },

                      responseDetailsApprenant?.mainProspect?.nationality ===
                        "تونسية" && {
                        label:
                          "Numéro de l'extrait de naissance - رقم مضمون الولادة",
                        value: responseDetailsApprenant?.mainProspect
                          ?.extrait_naissance
                          ? responseDetailsApprenant?.mainProspect
                              ?.extrait_naissance
                          : "",
                        type: "text",
                         name: "num_extrait_naissance",
                      },

                    //  responseDetailsApprenant?.mainProspect
                    //     ?.etablissement_formation_origine === "" 
                        responseDetailsApprenant?.mainProspect?.nationality !== "تونسية"
                        && responseDetailsApprenant?.mainProspect?.id_ministry &&                  
                           responseDetailsApprenant?.mainProspect
                        ?.etablissement_formation_origine &&
                        
                        {
                        label:
                           responseDetailsApprenant?.mainProspect
                        ?.etablissement_formation_origine === parseInt(import.meta.env.VITE_APP_ID_ETABLISSEMENT_ORIGINE_MINISTERE_EDUCATION) ? "Identifiant du ministère de l'éducation - معرّف وزارة التربية" : "Identifiant du ministère de l'enseignement supérieur - معرّف وزارة التعليم العالي",
                        value:
                          responseDetailsApprenant?.mainProspect?.id_ministry,
                        type: "text",
                             name: "id_ministere_education",
                      },

                      responseDetailsApprenant?.mainProspect?.nationality !==
                        "تونسية" && {
                        label: "N° passeport - رقم جواز السفر",
                        value: responseDetailsApprenant?.mainProspect?.passport
                          ? responseDetailsApprenant?.mainProspect?.passport
                          : "",
                        type: "text",
                         name: "num_passeport",
                      },
                      responseDetailsApprenant?.mainProspect?.nationality !==
                        "تونسية" && {
                        label:
                          "Date d'expiration du passeport - تاريخ انتهاء جواز السفر",
                        value:
                          responseDetailsApprenant?.mainProspect
                            ?.expiration_passeport,
                        type: "text",
                          name: "date_expiration_passeport",
                      },
                      responseDetailsApprenant?.mainProspect?.nationality !==
                        "تونسية" && {
                          label:
                            "Numéro de la carte séjour - رقم بطاقة الإقامة",
                          value: responseDetailsApprenant?.mainProspect
                            ?.carde_number
                            ? responseDetailsApprenant?.mainProspect
                                ?.carde_number
                            : "",
                          type: "text",
                           name: "num_carte_sejour",
                        },
                      {
                        label: "Nom (En français)  - اللقب (بالفرنسية)",
                        value: responseDetailsApprenant?.mainProspect?.name,
                        name: "last_name",
                        type: "text",
                          
                      },
                      {
                        label: "Prénom (En français) - الإسم (بالفرنسية)",
                        value: responseDetailsApprenant?.mainProspect?.surname,
                        name: "first_name",
                        type: "text",
                      },
                      {
                        label: "Nom (En arabe) - اللقب (بالعربية)",
                        value: responseDetailsApprenant?.mainProspect?.name_ar,
                        name: "last_name_ar",
                        type: "text",
                      },
                      {
                        label: "Prénom (En arabe) - الإسم (بالعربية)",
                        value:
                          responseDetailsApprenant?.mainProspect?.surname_ar,
                        name: "first_name_ar",
                        type: "text",
                      },
                      {
                        label:
                          "Lieu de naissance (En arabe) - مكان الولادة (بالعربية)",
                        value:
                          responseDetailsApprenant?.mainProspect
                            ?.lieu_naissance,
                        name: "birthplace",
                        type: "text",
                      },
                      {
                        label: "Gouvernorat de résidence - ولاية الإقامة",
                        value:
                          responseDetailsApprenant?.mainProspect?.goverment,
                        name: "residence_governorate",
                        type: "text",
                      },
                      {
                        label: "Délégation de résidence - معتمدية الإقامة",
                        value:
                          responseDetailsApprenant?.mainProspect?.delegation,
                        name: "residence_delegation",
                        type: "text",
                      },
                      {
                        label: "Code postal - الترقيم البريدي",
                        value:
                          responseDetailsApprenant?.mainProspect?.code_postal,
                        name: "residence_postal_code",
                        type: "text",
                      },

                      responseDetailsApprenant?.mainProspect?.nationality ===
                        "تونسية" && {
                        label:
                          "Nom du père (En français) - (بالفرنسية) اسم الأب",
                        value: responseDetailsApprenant?.mainProspect?.nom_pere,
                        name: "father_name",
                        type: "text",
                      },
                      responseDetailsApprenant?.mainProspect?.nationality ==
                        "تونسية" && {
                        label:
                          "Nom de la mère (En français) - (بالفرنسية) اسم الأم",
                        value: responseDetailsApprenant?.mainProspect?.nom_mere,
                        name: "mother_name",
                        type: "text",
                      },
                      responseDetailsApprenant?.mainProspect?.nationality ==
                        "تونسية" && {
                        label: "Nom du père (En arabe) - (بالعربية) اسم الأب",
                        value:
                          responseDetailsApprenant?.mainProspect?.nom_pere_ar,
                        name: "father_name_ar",
                        type: "text",
                      },
                      responseDetailsApprenant?.mainProspect?.nationality ==
                        "تونسية" && {
                        label:
                          "Nom de la mère (En arabe) - (بالعربية) اسم الأم",
                        value:
                          responseDetailsApprenant?.mainProspect?.nom_mere_ar,
                        name: "mother_name_ar",
                        type: "text",
                      },

                      {
                        label: "Genre - الجنس",
                        value: responseDetailsApprenant?.mainProspect?.civilite === "Mr" ? "Masculin - ذكر" :"Féminin - أنثى" ,
                        options: ["Féminin - أنثى", "Masculin - ذكر"],
                        name: "gender",
                        type: "radio",
                      },

                      {
                        label: "État civil - الحالة الاجتماعية",
                        value:
                          responseDetailsApprenant?.mainProspect?.etat_civile,
                        name: "marital_status",
                        type: "text",
                      },

                      {
                        label: "Adresse e-mail - البريد الإلكتروني",
                        value:
                          responseDetailsApprenant?.mainProspect?.adresse_mail,
                        name: "email",
                        type: "text",
                      },
                      {
                        label: "Numéro de téléphone - رقم الهاتف",
                        value: responseDetailsApprenant?.mainProspect?.tel,
                        name: "phone",
                        type: "text",
                      },
                      {
                        label: "Niveau scolaire - المستوى الدراسي",
                        value:
                          responseDetailsApprenant?.mainProspect?.niveau_etud,
                        name: "niveau_scolaire",
                        type: "text",
                      },
                      {
                        label:
                          "Personne à besoin spécifique - شخص ذو إحتياجات خصوصية ",
                        value:
                          responseDetailsApprenant?.mainProspect
                            ?.besoin_specifique === 0 ? "Non - لا" : "Oui - نعم",
                        name: "besoins_specifiques",
                        type: "radio",
                        options: ["Oui - نعم", "Non - لا"],
                      },
                      {
                        label:"Diplôme",
                        value: responseDetailsApprenant?.mainProspect
                            ?.documents?.content_diplome,
                        name: "copie_upload",
                        type: "upload"
                      },
                    ].filter(Boolean),
                  };
                  // debugger
                  const payload_add_affaire = {
                    ligne_produit: "bc6dc48b743dc5d013b1abaebd2faed2",
                    id_opp: null,
                    nom_produit: "THAMM PRODUCT (  )",
                    id_produit: "d728587fff2d87201eae0a158507d814",
                    cmp: "987654300",
                    affaire_parent: "",
                    user_id: JSON.parse(localStorage.getItem("-x-token-user"))
                      .id_user,
                    date_effet: "2024-01-02",
                    souscription: "2024-01-02",
                    id_fractionnement: 11,
                    affected: "1002237",
                    id_prospect: responseDetailsApprenant?.mainProspect?.id,
                    registration_number : responseDetailsEpf?.data?.message?.registration_number,
                    data_form_prod: JSON.stringify(json_prod),
                  };
                  const affaire = await addAffaire(payload_add_affaire);

                  if (affaire?.id_affaire) {
             

                       const id_type_doc = import.meta.env
                                .VITE_APP_ID_TYPE_DOC;
                                const fileList = [
  {
    content: record?.documents?.content_diplome_base64,
    name: record?.documents?.name_diplome,
  },
];
                              const formData = new FormData();
                              formData.append("id_affaire", affaire?.id_affaire);
                              formData.append("id_type_doc", id_type_doc);
                              formData.append("name_doc",record?.documents?.name_diplome);
                              formData.append("file_b64", JSON.stringify(fileList));
                                 
                              try {
                                const response = await uploadDocumentAffaire(formData);
                                if (response?.data.path) {
                                         const data = await updateActionAffaire({
                      id_affaire: affaire?.id_affaire,
                      id_status: import.meta.env
                        ?.VITE_APP_ID_DEMANDE_ELIGIBILITE_DEMANDE_SOUMISE,
                    });
                                   if (data) {
                      notification.success({
                        message: t(
                          `La demande de vérification pour ${
                            responseDetailsApprenant?.mainProspect?.name +
                            " " +
                            responseDetailsApprenant?.mainProspect?.surname
                          } a été transmise à la Direction Régionale. Elle est en cours de traitement.`
                        ),
                        duration: 0,
                      });
                      setLoading(false);
                      setRefresh(!refresh);
                    }
                                }
                              } catch (error) {
                            setLoading(false);
                                notification.error({
                                  message: t(
                                    "Une erreur est survenue lors du téléversement de votre document. Veuillez réessayer."
                                  ),
                                  duration: 0,
                                });
                              }







                  
                  }
                })
                .catch((error) => {
                  notification.error({
                    message: t("Erreur"),
                    description: t(error?.data?.message),
                    duration: 0,
                  });
                  setLoading(false);
                });
            })
            .catch((error) => {
              setLoading(false);
              notification.error({
                message: t("Erreur"),
                description: t(error?.data?.message),
                duration: 0,
              });
            });
        } else {
          notification.error({
            message: t("Erreur"),
            description: t(
              "Une vérification d’éligibilité est actuellement en cours pour ce demandeur. Tant que celle-ci n’a pas été acceptée ou refusée, aucune autre demande ne peut être effectuée. Merci de votre compréhension."
            ),
            duration: 0,
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        notification.error({
          message: t("Erreur"),
          description: t(error?.data?.message),
          duration: 0,
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    console.log("role", role);
  }, []);

  const columns = [
    {
      title: t("Nom"),
      key: "Nom",
      render: (_, record) => (record?.name ? record?.name : t("Non renseigné")),
    },
    {
      title: t("Prénom"),
      key: "Prénom",
      render: (_, record) =>
        record?.surname ? record?.surname : t("Non renseigné"),
    },
    {
      title: t("Nationnalité"),
      key: "Nationnalité",
      render: (_, record) =>
        record?.nationality ? record?.nationality : t("Non renseigné"),
    },
    {
      title: t("Cin / Passeport"),
      key: "Cin / Passeport",
      render: (_, record) =>
        record?.nationality === "تونسية" ? record?.cin : record?.passport,
    },

    {
      title: t("Spécialité ou Domaine"),
      key: "Spécialité ou Domaine",
      render: (_, record) => {
        const text = record?.specialite || t("Non renseigné");
        return (
          <Tooltip title={text}>
            <span>
              {text.length > 20 ? `${text.substring(0, 20)} ...` : text}
            </span>
          </Tooltip>
        );
      },
    },

    {
      title: t("Statut"),
      key: "statut",
      render: (_, record) => {
        return (
          <span
            style={{
              padding: "4px 10px",
              borderRadius: "5px",
              fontSize: "12px",
              backgroundColor: record?.statut_couleur_background,
              color: record?.couleur_statut,
            }}
          >
            {
            record?.demande_eligibilite_id_statut?.toString() ===
              import.meta.env
                .VITE_APP_ID_DEMANDE_ELIGIBILITE_EN_COURS_DE_TRAITEMENT ||
            record?.demande_eligibilite_id_statut?.toString() ===
              import.meta.env.VITE_APP_ID_DEMANDE_ELIGIBILITE_DEMANDE_SOUMISE ||
            record?.demande_eligibilite_id_statut?.toString() ===
              import.meta.env
                .VITE_APP_ID_DEMANDE_ELIGIBILITE_DEMANDE_DOSSIER_MANQUANT || record?.demande_eligibilite_id_statut?.toString() ===
             import.meta.env
                .VITE_APP_ID_DEMANDE_ELIGIBILITE_DEMANDE_COMPLEMENT_SOUMIS
              ? t(record?.demande_eligibilite_statut)
              : 
              t(record?.statut_apprenant)}
          </span>
        );
      },
    },

    {
      title: "Actions",
      key: "autre",
      render: (_, record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: (
                  <Button
                    size="small"
                    block
                    onClick={() =>
                 
                       consulterPreInscrit(record, "consulter")
                      }
                  >
                    {t("Consulter")}
                  </Button>
                ),
                key: "1",
              },
              {
                label: ["investisseur-directeur", "directeur"].includes(
                  role
                ) && (
                  <Button
                    onClick={() => ajouterDemandeVerification(record)}
                    disabled={[
                    parseInt(import.meta.env.VITE_APP_ID_STATUT_APPRENANT_ELIGIBLE),
                    parseInt(import.meta.env.VITE_APP_ID_STATUT_APPRENANT_INDISPONIBLE),
                    parseInt(import.meta.env.VITE_APP_ID_STATUT_APPRENANT_EN_FORMATION),
                  ].includes(record?.id_statut_apprenant)}
                    size="small"
                    block
                  >
                    {t("Demander la vérification")}
                  </Button>
                ),
                key: "2",
              },

              {
                label: (
                  record?.demande_eligibilite_id_statut?.toString() === import.meta.env.VITE_APP_ID_DEMANDE_ELIGIBILITE_DEMANDE_DOSSIER_MANQUANT  && (
                  <Button
                    block
                    size="small"
                    onClick={async () => {
                      setIsLoading(true);
                      const data = await getSchema(
                        record?.demande_eligibilite_id
                      );
                      consulterPreInscrit(record, "complement_dossier", data);
                      setIsLoading(false);
                    }}
                  >
                    {t("Compléter la demande")}
                  </Button>
                  )
                ),
              },

              // {
              //   label: (
              //     <Button size="small" block
              //     onClick={() =>  {
              //       setDemandeurDetails(record)
              //       setConfirmModal(true)
              //     }}
              //     >

              //       {t("Supprimer")}
              //     </Button>
              //   ),
              //   key: "3",
              // },

              {
                label: (
                  <Button
                    size="small"
                    block
                    onClick={() => {
                      if (record?.nationality === "تونسية") {
                        updatePreInscrit(record);
                      } else {
                        getCheckModificationApprenant(
                          // record?.demande_eligibilite_id_statut
                          record?.id
                        )
                          .then((response) => {
                            if (response?.modifiable) {
                              updatePreInscrit(record);
                            } else {
                              notification.error({
                                message: t("Erreur"),
                                description: t(
                                  "Une vérification d'éligibilité est actuellement en cours pour ce demandeur. Tant que celle-ci n'a pas été acceptée ou refusée, aucune modification ne peut être effectuée. Merci de votre compréhension."
                                ),
                                duration: 0,
                              });
                              setLoading(false);
                            }
                          })
                          .catch((error) => {
                            notification.error({
                              message: t("Erreur"),
                              description: t(error?.data?.message),
                              duration: 0,
                            });
                            setLoading(false);
                          });
                      }
                    }}
                  >
                    {t("Modifier")}
                  </Button>
                ),
                key: "3",
              },

              {
                label: (
                  // record?.nationality !== "تونسية" && (

                  <Button
                    size="small"
                    block
                    // disabled={record?.nationality ==="تونسية"}
                    onClick={() => {
                      setDemandeurDetails(record?.surname + " " + record?.name);
                      handleGetComment(record?.demande_eligibilite_id)
                        .then(async (response) => {
                          if (response?.info?.length > 0) {
                            setCommentaire(response?.info);
                          } else {
                            notification.warning({
                              message: t(
                                "Vous ne disposez pas de commentaire pour cette demande !"
                              ),
                              duration: 0,
                            });
                          }
                        })
                        .catch((error) => {
                          notification.error({
                            message: t("Erreur"),
                            description: t(error?.data?.message),
                            duration: 0,
                          });
                        });
                    }}
                  >
                    {t("Commentaires")}
                  </Button>
                ),
                key: "3",
              },

              {
                label: record?.nationality !== "تونسية" &&
                  record?.url_pre_inscription_base64 && (
                    <Button
                      size="small"
                      block
                      disabled={record?.nationality === "تونسية"}
                      onClick={() => {
                        setIsLoading(true);
                        downloadFile(
                          record?.url_pre_inscription_base64,
                          "attestation_préinscription"
                        );
                        setIsLoading(false);
                      }}
                    >
                      {t("Télécharger une attestation de préinscription ")}
                    </Button>
                  ),
                key: "3",
              },
            ],
          }}
          trigger={["click"]}
        >
          <a onClick={(e) => e.preventDefault()}>
            <Space>
              {t("Liste")}
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      ),
    },
  ];

  const dataSourceWithKeys = data.map((item, index) => ({
    ...item,
    key: index,
  }));

  const handleDeletePreInscrits = (record) => {
    let selectedIds = [];
    if (record) {
      selectedIds = [
        { id_formation: record.id_formation, id_apprenant: record.id },
      ];
    } else {
      selectedIds = selectedRows.map((row) => ({
        id_formation: row.id_formation,
        id_apprenant: row.id,
      }));
    }

    axiosInstance
      .delete(
        `${import.meta.env.VITE_APP_GEOPROD_API}/delete_apprenant_session`,
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
          data: {
            apprenants: selectedIds,
          },
        }
      )
      .then(() => {
        notification.success({
          message: "Succès",
          description: record
            ? t(
                `Le demandeur de formation ${
                  record?.surname + " " + record?.name
                } a été supprimé avec succès.`
              )
            : t(
                "Les demandeurs de formation sélectionnés ont été supprimés avec succès"
              ),
        });
        setSelectedRows([]);
        setRefresh(!refresh);
        setLoading(false);
        setConfirmModal(false);
      })
      .catch((error) => {
        notification.error({
          message: t("Erreur"),
          description: t(error?.response?.data?.message),
          duration: 0,
        });
        setConfirmModal(false);
        setLoading(false);
      });
  };

  const fetchData = async (page = 1, pageSize = 10) => {
    setLoading(true);
    axiosInstance
      .get(
        `${
          import.meta.env.VITE_APP_GEOPROD_API
        }/list_apprenant?page=${page}&limit=${pageSize}`,
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      )
      .then((res) => {
        setData(res?.data?.message?.Data);
        setPagination((prev) => ({
          ...prev,
          current: page,
          pageSize,
          total: res.data.message.totalCount, // Total des éléments
        }));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData(pagination.current, pagination.pageSize);
  }, [refresh]);

  const handleTableChange = (pagination) => {
    fetchData(pagination.current, pagination.pageSize);
  };

  return (
    <Spin spinning={loading} tip="" style={{ width: "100%" }}>
      <div>
        <Modal
          open={confirmModal}
          footer={null}
          width={600}
          onCancel={() => setConfirmModal(false)}
        >
          <h4>
            {demandeurDetails
              ? t(
                  `Êtes-vous sûr de vouloir supprimer le demandeur ${
                    demandeurDetails?.surname + " " + demandeurDetails?.name
                  } ? Cette action est irréversible.`
                )
              : t(
                  "Êtes-vous sûr de vouloir supprimer les demandeurs sélectionnés ? Cette action est irréversible"
                )}
          </h4>
          <Button
            type="primary"
            onClick={() => handleDeletePreInscrits(demandeurDetails)}
          >
            {t("Oui")}
          </Button>
          <Button
            type="primary"
            style={{ marginInline: "15px" }}
            onClick={() => setConfirmModal(false)}
          >
            {t("Non")}
          </Button>
        </Modal>
        <CommentModal
          commentaire={commentaire}
          setCommentaire={setCommentaire}
          title={demandeurDetails}
        />
        <Card
          className={classes.listeCard}
          bordered={false}
          title={
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3>
                  {t(
                    "Liste des vérifications de l'éligibilité pour les formations homologuées"
                  )}
                </h3>
              </div>
            </div>
          }
        >
          <Table
            dataSource={dataSourceWithKeys}
            columns={columns}
            // rowSelection={{
            //   type: "checkbox",
            //   ...rowSelection,
            // }}
            // loading={loading}
            className="ant-border-space"
            style={{ overflowX: "auto" }}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </Card>
      </div>
    </Spin>
  );
};

export default PreInscritList;
